<template>
  <div class="container">
    <CollapsibleListItem icon="mdi-email-outline" :title="$t('MEMBER.CONTACT')" :expanded="true">
      
      <div v-if="company.profile">

        <m-row class="mt-4">
          <m-col sm="12" md="4" v-if="company.profile.em">
            <memlist-text-input 
              :title="$t('MEMBER.EMAIL')" 
              v-model="local_member.email" 
              @input="change_save_data"
            />
          </m-col>
          <m-col sm="12" md="4" v-if="company.profile.ph">
            <memlist-text-input 
              :title="$t('MEMBER.PHONE')" 
              v-model="local_member.phone" 
              @input="change_save_data"
            />
          </m-col>
          <m-col sm="12" md="4" v-if="company.profile.ph">
            <memlist-text-input 
              :title="$t('MEMBER.LANDLINE')" 
              v-model="local_member.landline"
              @input="change_save_data"
            />
          </m-col>
        </m-row>

        <m-row class="mt-4" v-if="company.profile.communication !== false && company.profile.communication !== 0">
          <m-col lg="12">
            <div class="checkbox-list">
              <memlist-checkbox 
                :value="true"
                :text="$t('MEMBER.SYS')"
                v-model="local_member.sys"
                @input="change_save_data"
              />

              <memlist-checkbox 
                :value="true"
                :text="$t('MEMBER.DEF')"
                v-model="local_member.def"
                @input="change_save_data"
              />

              <memlist-checkbox 
                :value="true"
                :text="$t('MEMBER.IMP')"
                v-model="local_member.imp"
                @input="change_save_data"
              />
            </div>
          </m-col>
        </m-row>

        <m-row class="mt-4" v-if="!local_member.imp || !local_member.def || !local_member.sys">
          <m-col lg="12">
            <memlist-text-input 
              v-model="local_member.freetext"
              :title="$t('MEMBER.FREETEXT')"
            />
          </m-col>
        </m-row>

        <RightSaveButton
          class="mt-4 mr-4"
          ref="save-button"
          :text="$t('COMMON.SAVE')"
          @clicked="save_button_clicked()"
        />

      </div>
      
    </CollapsibleListItem>

  </div>

</template>


<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import RightSaveButton from '@/view/components/buttons/RightSaveButton.vue';
import CollapsibleListItem from './CollapsibleListItem.vue';


export default {

  name: 'MemberContactDetailsComponent',

  props: ['member','company','expanded'],
  emits: ['save_data'],
  mixins: [ toasts ],

  components: {
    RightSaveButton,
    CollapsibleListItem
  },

  watch: {

    member: {
      deep: true,
      handler(val) {
        this.local_member = { ...this.member }
      }
    },
  },

  computed: {

  },

  methods: {
    change_save_data() {},
    save_button_clicked() {
      setTimeout(()=>{
        this.$refs['save-button'].stop();
      },500);

      this.save_data();
    },

    async save_data() {
      this.$emit('save_data', this.local_member);
    }

  },

  mounted() {
    this.local_member = { ...this.local_member };
    this.show_form = this.expanded;
  },

  data() {
    return {

      local_member: {},

      show_form: true,

      gender_options: [
        { text: this.$t('COMMON.MALE'), value: 'M' },
        { text: this.$t('COMMON.FEMALE'), value: 'F' },
        { text: this.$t('COMMON.OTHER'), value: 'O' },
        { text: this.$t('COMMON.UNKNOWN'), value: 'U' },
      ],

    };
  }
};

</script>

<style lang="scss" scoped>
  
  
</style>
